import { PlacementRoutes } from './Placement.routes'

export default [...PlacementRoutes]
